import { ComponentStyleConfig } from '@chakra-ui/react'

export const DividerStyles: ComponentStyleConfig = {
    baseStyle: ({ colorMode }) => ({
        borderColor: `${colorMode}.tones.periwinkle`,
        opacity: 1
    })
}
